import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "/booking-meeting-room-service";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  room_meeting_type?: string;
};

export type booking_meeting_service_data = {
  id_room_meeting: number | null;
  id_room_metting_service: number | null;
  qty: number | string;
  room_meeting_service_desc: string;
  room_metting_service_amount: number | string;
  room_metting_service_amount_usd: number | string;
  status: string;
  room_metting_service_name?: string;
}

export interface listMeetingBookingService extends pagination_list {
  id_meeting_room?: number;
}

export class BookingMeetingRoomServiceApi extends BaseAPI {
  static createServiceToMeetingRoom(body: any): Promise<any> {
    return this.api.post(`${path}/meeting-room-service`, body);
  }
  static createServiceToMeetingRoomWithType(body: booking_meeting_service_data): Promise<AxiosResponse> {
    return this.api.post(`${path}/meeting-room-service`, body);
  }
  static updateServiceToMeetingRoom(id_meeting_room_service: number, body: booking_meeting_service_data): Promise<AxiosResponse> {
    return this.api.patch(`${path}/meeting-room-service/${id_meeting_room_service}`, body);
  }

  static updateServiceInMeetingRoom(
    id_meeting_room: number,
    body: any
  ): Promise<any> {
    return this.api.patch(`${path}/meeting-room-service/${id_meeting_room}`, body);
  }

  static deleteServiceImMeetingRoomById(id: number): Promise<AxiosResponse> {
    return this.api.delete(`${path}/meeting-room-service/${id}`);
  }
  static listMeetingBookingService(params: listMeetingBookingService): Promise<AxiosResponse> {
    return this.api.get(`${path}/list`, { params })
  }
  static createBookingMeetingRoom(body: booking_meeting_service_data): Promise<AxiosResponse> {
    return this.api.post(`${path}/meeting-room-service`, body)
  }
  static updateBookingMeetingRoom(id_meeting_room_service: number, body: booking_meeting_service_data): Promise<AxiosResponse> {
    return this.api.patch(`${path}/meeting-room-service/${id_meeting_room_service}`, body)
  }
}
